import { get, patch, post, remove } from "@services/apiService.js";
export default {

  getDirectories() {
    return get(`/v4/filemanager/v1/directories`, {})
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        throw error;
      });
  },
  getFiles(directoryID, options) {
    return get(`/v4/filemanager/v1/directory/${directoryID}/files`, options)
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        throw error;
      });
  },
  getDisklUsed() {
    return get(`/v4/filemanager/v1/checkdisk`, {})
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        throw error;
      });
  },
  uploadfiles(data, onUploadProgress, options) {
    return post(`/v4/filemanager/v1/file`, data, { 'Content-Type': 'multipart/form-data' }, { onUploadProgress, ...options })
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        throw error;
      });
  },
  updateDisplayType(data) {
     const req = post(`/v4/user-preference/v1/filemanager/configs`, data)
      req.then(response => {
        return response.data || {};
      })
      .catch(error => {
        return error.response
      });
  },
  updateFile(fileID, options) {
    return patch(`/v4/filemanager/v1/file/${fileID}`, options)
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        throw error;
      });
  },
  checkDirValid(options) {
    return post(`/v4/filemanager/v1/directory/checkvalidname`, options)
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        return error.response
      });
  },
  addDirectory(options) {
    return post(`/v4/filemanager/v1/directory`, options)
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        return error.response
      });
  },
  deleteDirectory(directoryID, options) {
    return remove(`/v4/filemanager/v1/directory/${directoryID}`, options)
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        return error.response
      });
  },
  deleteFiles(options) {
    return remove(`/v4/filemanager/v1/file`, options)
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        return error.response
      });
  },
  updateFileDimension(fileID, options) {
    return patch(`/v4/filemanager/v1/file/${fileID}/dimension`, options)
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        throw error;
      });
  },
  getDisplay() {
    return get(`/v4/user-preference/v1/filemanager/configs`)
      .then(response => {     
        return response.data || {};
      })
      .catch(error => {
        throw error;
      });
  },
  getUnsplash(options) {
    const option = {
      p: options.p,
      take: options.take,
      name: options.name,
      categoryID : options.categoryID,
    }
    if(option.categoryID === 0) {
      delete option.categoryID;
    }
    return get(`/v4/unsplash/v1/photos`,option)
      .then(response => {     
        return response.data || {};
      })
      .catch(error => {
        throw error;
      });
  },
  getUnsplashDefault(options) {
    const option = {
      p: options.p,
      take: 30,
    }
    return get(`/v4/unsplash/v1/photos/default`,option)
      .then(response => {     
        return response.data || {};
      })
      .catch(error => {
        throw error;
      });
  },
  getCategoriesUnsplash() { 
    return get(`/v4/unsplash/v1/categories`)
      .then(response => {     
        return response.data || {};
      })
      .catch(error => {
        throw error;
      }); 
  },
  getFlaticonPacks(options){
    return get(`/v4/flaticon/v1.1/packs`,options)
      .then(response => {     
        return response.data || {};
      })
      .catch(error => {
        throw error;
    }); 
  },
  getFlaticonPack(id,options){
    return get(`/v4/flaticon/v1/pack/${id}`,options)
      .then(response => {     
        return response.data || {};
      })
      .catch(error => {
        throw error;
    }); 
  },
  getFlaticonIcons(options){
    return get(`/v4/flaticon/v1/icons`,options)
      .then(response => {     
        return response.data || {};
      })
      .catch(error => {
        throw error;
    }); 
  },
  importFlaticon(id,data) {
    return post(`/v4/flaticon/v1/icon/${id}/download`, data)
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        return error.response
      });
  },
  importUnsplash(data) {
    return post(`/v4/unsplash/v1/photos/import`, data)
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        return error.response
      });
  },
  getCategoriesIcon(options){
    return get(`/v4/icon/v1/categories`,options)
      .then(response => {     
        return response.data || {};
      })
      .catch(error => {
        throw error;
    })
  },
  getIcons(options){
    return get(`/v4/icon/v1/icons`,options)
      .then(response => {     
        return response.data || {};
      })
      .catch(error => {
        throw error;
    }); 
  },
  importIcon(id){
    return post(`/v4/icon/v1/icon/${id}/download`)
    .then(response => {
      return response.data || {};
    })
    .catch(error => {
      return error.response
    });
  },
  getImagesID() {
    return get(`/v4/filemanager/v1/imagesid`, {})
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        throw error;
      });
  },
};
